import MapboxDraw from '@mapbox/mapbox-gl-draw'
import { isActiveFeature, isInactiveFeature, isVertex, noTarget } from '@mapbox/mapbox-gl-draw/src/lib/common_selectors'
import cloneDeep from 'lodash.clonedeep'

import DirectSelectRouteModeCommon from './DirectSelectRouteModeCommon'

const DirectSelectZoneRouteMode = cloneDeep(MapboxDraw.modes.direct_select)

DirectSelectZoneRouteMode.clickInactive = function () {}

DirectSelectZoneRouteMode.clickNoTarget = function () {}

DirectSelectZoneRouteMode.onVertex = DirectSelectRouteModeCommon.onVertex

DirectSelectZoneRouteMode.onClick = DirectSelectRouteModeCommon.onClick

export default DirectSelectZoneRouteMode
